import React, { useEffect, useState } from "react";
import { NavLink, Navigate, Outlet, useNavigate, useLocation } from "react-router-dom";
import "./OpsLayout.css";

const OPERATOR_ROLES = ["support", "superadmin"];

export default function OpsLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem("userToken");
  const role = (localStorage.getItem("userRole") || "").toLowerCase();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }

    if (!OPERATOR_ROLES.includes(role)) {
      navigate("/dashboard", { replace: true });
    }
  }, [token, role, navigate]);

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setSidebarOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!OPERATOR_ROLES.includes(role)) {
    return null;
  }

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login", { replace: true });
    window.location.reload();
  };

  const handleNavClick = () => {
    if (typeof window !== "undefined" && window.innerWidth < 992) {
      setSidebarOpen(false);
    }
  };

  return (
    <div className={`ops-shell${sidebarOpen ? " ops-shell-mobile" : ""}`}>
      <aside className={`ops-sidebar${sidebarOpen ? " open" : ""}`}>
        <div className="ops-brand">Ops Console</div>
        <nav>
          <NavLink
            to="/ops/overview"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={handleNavClick}
          >
            Overview
          </NavLink>
          <NavLink
            to="/ops/analytics"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={handleNavClick}
          >
            Analytics
          </NavLink>
          <NavLink
            to="/ops/companies"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={handleNavClick}
          >
            Companies
          </NavLink>
          <NavLink
            to="/ops/partners"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={handleNavClick}
          >
            Partners
          </NavLink>
          <NavLink
            to="/ops/users"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={handleNavClick}
          >
            Users
          </NavLink>
          <NavLink
            to="/ops/imessage"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={handleNavClick}
          >
            iMessage Fleet
          </NavLink>
          <NavLink
            to="/ops/audit-log"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={handleNavClick}
          >
            Audit Log
          </NavLink>
          <NavLink
            to="/ops/announcements"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={handleNavClick}
          >
            Announcements
          </NavLink>
          <NavLink
            to="/ops/billing"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={handleNavClick}
          >
            Billing
          </NavLink>
          <NavLink
            to="/ops/mobile-releases"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={handleNavClick}
          >
            Mobile Releases
          </NavLink>
          <NavLink
            to="/ops/email-settings"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={handleNavClick}
          >
            Email Settings
          </NavLink>
        </nav>
      </aside>
      {sidebarOpen && <div className="ops-sidebar-backdrop" onClick={() => setSidebarOpen(false)} />}
      <main className="ops-main">
        <header className="ops-topbar">
          <button
            type="button"
            className="ops-menu-btn d-lg-none"
            onClick={() => setSidebarOpen((prev) => !prev)}
            aria-label="Toggle menu"
          >
            <i className="bi bi-list" />
          </button>
          <div>
            <h1>
              {(() => {
                if (location.pathname.includes("/analytics")) return "Analytics";
                if (location.pathname.includes("/companies")) return "Companies";
                if (location.pathname.includes("/partners")) return "Partners";
                if (location.pathname.includes("/announcements")) return "Announcements";
                if (location.pathname.includes("/audit-log")) return "Audit Log";
                if (location.pathname.includes("/imessage")) return "iMessage Fleet";
                if (location.pathname.includes("/users")) return "Users";
                if (location.pathname.includes("/billing")) return "Billing";
                if (location.pathname.includes("/mobile-releases")) return "Mobile Releases";
                if (location.pathname.includes("/email-settings")) return "Email Settings";
                return "Overview";
              })()}
            </h1>
            <p className="ops-topbar-subtitle">You are viewing the global operator workspace.</p>
          </div>
          <div className="ops-actions">
            <button className="btn btn-outline-secondary" onClick={() => navigate("/dashboard")}>
              Back to Portal
            </button>
            <button className="btn btn-primary" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </header>
        <div className="ops-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
